// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef, useState } from 'react';
import { bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

import useUser from 'Hooks/useUser';
import useOutsideClick from 'Hooks/useOutsideClick';
import AccountManagerComponent from 'Components/AccountManager/AccountManager';

const AccountManagerContainer = ({ isHeader }) => {
  const creditRef = useRef(null);
  const isCreditVisible = useOutsideClick(creditRef);
  const { t } = useTranslation();
  const { data: user } = useUser();
  const [menuOpen, openMenu] = useState(false);

  useEffect(() => {
    openMenu(isCreditVisible);
  }, [isCreditVisible]);

  const onClick = () => openMenu(prevState => !prevState);

  if (!user || !user.accountManager) {
    return null;
  }

  const { firstName, lastName, email, phone } = user.accountManager;
  if (!firstName || !lastName || !email || !phone) {
    return null;
  }

  return (
    <AccountManagerComponent
      ref={ creditRef }
      accountManager={ user.accountManager }
      accountManagerLabel={ t('profile.accountManager') }
      onToggle={ onClick }
      menuOpen={ menuOpen }
      isHeader={ isHeader }
    />
  );
};

AccountManagerContainer.propTypes = {
  isHeader: bool,
};

export default AccountManagerContainer;
